import { OptionsValues, PaginationResult } from '../../models';
import { catchError, map, Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';

//NOTE: POST isteğiyle search yapılan eski API'lar için kullanılan service

export class LegacyBaseApiService<T> extends BaseApiService<T> {
	public override findPageableObjects(
		pageNumber: number,
		pageInSize: number,
		sort: string | string[],
		searchObject: string | object
	): Observable<PaginationResult<T>> {
		const url = this.apiUrl + '/search?page=' + pageNumber + '&size=' + pageInSize + (sort ? '&sort=' + sort : '');
		return this._restClientService.post(url, JSON.stringify(searchObject)).pipe(catchError(this.handleError));
	}

	public findListObjects(searchObject?: object): Observable<T[]> {
		if (!searchObject) {
			return this._restClientService.get(this.apiUrl).pipe(catchError(this.handleError));
		} else {
			return this._restClientService
				.post(this.apiUrl + '/list', JSON.stringify(searchObject))
				.pipe(catchError(this.handleError));
		}
	}

	public override getOptionList({
		searchArgs = {},
		label = 'name',
		value = 'id',
		sort = 'creDate,ASC',
	} = {}): Observable<OptionsValues> {
		return this.findPageableObjects(0, 200, sort, searchArgs).pipe(
			map((result) => result.content || []),
			map((result) =>
				result.map((item: T) => {
					const row = item as unknown as Record<string, unknown>;
					return {
						label: String(row[label] ?? ''),
						value: row[value] as string | number | boolean,
					};
				})
			)
		);
	}

	public override getList(searchArgs: object = {}, size = 200, sort = 'creDate,ASC'): Observable<T[]> {
		return this.findPageableObjects(0, size, sort, searchArgs).pipe(map((result) => result.content || []));
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public override getSingle(searchArgs: any = {}, relationNames?: string[], sort = 'creDate,DESC'): Observable<T> {
		searchArgs.searchCriteriaOptions = {
			...searchArgs.searchCriteriaOptions,
			dataGraph: relationNames ? this.prepareDataGraphObjects(relationNames) : null,
			recordCountRequired: false,
		};
		return this.findPageableObjects(0, 1, sort, searchArgs).pipe(map((result) => result.content?.[0] as T));
	}

	private prepareDataGraphObjects(relationNames: string[] = []): { relationName: string }[] {
		const dataGraph: { relationName: string }[] = [];
		relationNames.forEach((value) => {
			dataGraph.push({
				relationName: value,
			});
		});
		return dataGraph;
	}
}
